import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './confpan.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import mst_chnl_conf from './../../../WidgetCollection/ms_teams/confpan/mst_chnl_conf/mst_chnl_conf'; //cannot find module.. - DOCH KANN ER
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import teams_channel_finder from './teams_channel_finder/teams_channel_finder';
import teams_team_finder from './teams_team_finder/teams_team_finder';
import channel_tab_configuration from './channel_tab_configuration/channel_tab_configuration';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';

class confpan extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private displayTableContainer: HTMLDivElement;
    private displayTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private tableID: string = "ID";
    private configWidgetRegestry: Record<string, MdsLax<InstanceType<typeof mst_chnl_conf>>> = {};
    private configurationDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private channelTabEditor: MdsLax<InstanceType<typeof channel_tab_configuration>> = null;

    private linkContainer:HTMLDivElement;
    private myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private mdscTabAppIsInstalledInTeams: boolean = false;
    private channelEditor: MdsLax<InstanceType<typeof mst_chnl_conf>> = null;
    private reloadTimeout: any = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.reloadData();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private async reloadData() {
        this.showLoading();

        let originalMinHeight = this.displayTableContainer.style.minHeight + "px";
        if (originalMinHeight == "px") {
            originalMinHeight = "unset";
        }
        this.displayTableContainer.style.minHeight = this.displayTableContainer.getBoundingClientRect().height + "px";

        let mdscInstallationStatus: any = null;
        let tableDataResult: GetChannelDataResponse = null;

        try {
            // App installation status promise
            const mdscInstallationStatusProm: Promise<any> = new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_API_MS_Teams_Integration_AdminPanel__GetMdscAppInstalationStatus",
                    {},
                    lang.hitch(this, (apiResult: any) => {
                        resolve(apiResult);
                    }),
                    lang.hitch(this, (err) => {
                        console.error(err.Message);
                        this.showToast(err.Message, "fas fa-bug");
                        reject(err);
                    })
                );
            });

            // Channel data promise
            const requestResultProm: Promise<GetChannelDataResponse> = new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_API_MS_Teams_Integration_AdminPanel__GetChannels",
                    {},
                    lang.hitch(this, (apiResult: any) => {
                        resolve(apiResult);
                    }),
                    lang.hitch(this, (err) => {
                        console.error(err.Message);
                        this.showToast(err.Message, "fas fa-bug");
                        reject(err);
                    })
                );
            });

            // beide requests gleichzeitig
            [mdscInstallationStatus, tableDataResult] = await Promise.all([mdscInstallationStatusProm, requestResultProm]);

        } catch (error) {
            console.error("Error during reloadData:", error);
            //error wird bei reject angezeigt
            this.displayTableContainer.style.minHeight = originalMinHeight;
            this.hideLoading();
            return;
        }

        // Handle app installation status
        let isInstalled = mdscInstallationStatus?.teamsAppIsInstalled ?? false;
        if (isInstalled) {
            let showToast = true;
            try{
                showToast = window.localStorage.getItem("msTeams_flag_appInstalled") == null;
            }catch{
                showToast = true;
            }
            if (showToast){
                this.showToast({
                    message: this.translate("MsTeamsIntegration_AdminPanel_AppStatus_Installed"),
                    title: this.translate("MsTeamsIntegration_AdminPanel_AppStatus_Installed_short"),
                    iconClass: "fas fa-info w3-text-blue",
                    modalSize: 'smaller',
                    showClose: true,
                    timeout: 15000,
                });
                try{
                    window.localStorage.setItem("msTeams_flag_appInstalled", "1");
                }catch{}
            }
        } else {
            this.showToast({
                message: this.translate("MsTeamsIntegration_AdminPanel_AppStatus_NotInstalled"),
                title: this.translate("MsTeamsIntegration_AdminPanel_AppStatus_NotInstalled_short"),
                iconClass:"fas fa-exclamation-triangle w3-text-red",
                modalSize:'larger',
                showClose:true,
                timeout:'permanent',
            });
        }
        this.mdscTabAppIsInstalledInTeams = isInstalled;

        // Handle table data
        if (Object.keys(this.configWidgetRegestry).length > 0) {
            for (let key of Object.keys(this.configWidgetRegestry)) {
                try {
                    this.configWidgetRegestry[key].destroyRecursive();
                } catch { }
            }
            this.configWidgetRegestry = {};
        }
        if (this.displayTable != null) {
            try {
                this.displayTable.destroyRecursive();
            } catch { }
            this.displayTableContainer.innerHTML = "";
        }

        this.displayTable = new StaticTable();
        this.displayTable.placeAt(this.displayTableContainer);
        this.displayTable.setLayout

        this.tableID = tableDataResult.IdAttributeName ?? "ID";
        if (Array.isArray(tableDataResult.tableLayoutJsonString)) {
            tableDataResult.tableLayoutJsonString = (tableDataResult.tableLayoutJsonString as Array<any>).pop();
        }
        this.displayTable.setTableLayout(tableDataResult.tableLayoutJsonString);
        this.displayTable.setFormatter(lang.hitch(this, this.table_formater));
        this.displayTable.addCustomRowActionButton(
            "openChannelEditor",
            lang.hitch(this, this._onClick_OpenEdit),
            "fas fa-edit",
            null,
            0,
            this.translate("MsTeamsIntegration_AdminPanel_OpenChannelEditor"),
            true,
            true
        );
        this.displayTable.addDefaultRowActionButton(
            'delete',
            lang.hitch(this, this.onDelete_Channel),
            lang.hitch(this, this.onIsDeletable_Channel),
            true
        );
        this.displayTable.addCustomRowActionButton(
            "openChannelOptions",
            lang.hitch(this, this.onOpenTabEditor),
            "fas fa-window-restore",
            null,
            1,
            this.translate("MsTeamsIntegration_AdminPanel_OpenTabMenu"),
            lang.hitch(this, this.onCanOpenTabEditor),
            true
        );
        this.displayTable.addCustomRowActionButton(
            "openWebUri",
            lang.hitch(this, (rowGroup: { entity: TeamsChannelApiData }) => {
                let targetUrl = rowGroup.entity.web_url;

                this.linkContainer.innerHTML = "";
                const a = document.createElement("a");
                a.href = targetUrl;
                a.target = "_blank";
                a.rel = "noopener";
                a.style.display = "none";
                this.linkContainer.appendChild(a);
                a.click();
                this.linkContainer.removeChild(a);
            }),
            "fas fa-external-link-alt",
            null,
            Number.MAX_SAFE_INTEGER,
            this.translate("MsTeamsIntegration_AdminPanel_OpenInTeams"),
            (entity: TeamsChannelApiData) => {
                if (typeof entity?.web_url == 'string') {
                    const urlRegex: RegExp = /^(?:https?:\/\/)?[^\s\/$.?#].[^\s]*$/i;
                    if (urlRegex.test(entity.web_url)) {
                        return true;
                    }
                }
                return false;
            },
            true
        );

        this.displayTable.setContentOverflowClip(true);
        this.displayTable.setVerticalAlign('middle');
        this.displayTable.setData(tableDataResult.channels, this.tableID);

        this.displayTableContainer.style.minHeight = originalMinHeight;
        this.hideLoading();
    }

    private table_formater(cell: StaticTable.StaticTableCell<any>): boolean {
        let reflectChanges = true;
        let node = cell.contentnode;
        let entity: TeamsChannelApiData = cell.entity;
        let columnName: string = cell.name;

        let cellContainer = document.createElement('div');
        for (let k of Object.keys(entity)) {
            node.setAttribute("data-" + k, entity[k]);
        }
        node.innerHTML = "";
        node.appendChild(cellContainer);

        switch (columnName.toLowerCase()) {
            case "parentTeamID".toLowerCase():
                let teamsTeamName = entity.parentTeamDisplayName ?? "";
                teamsTeamName = teamsTeamName.trim();
                if (teamsTeamName == "") {
                    teamsTeamName = this.getTranslation("General_Label_Undefined");
                }
                let ico = document.createElement("i");
                ico.classList.add("fas", "fa-users", "w3-padding-right");


                let nameSpan = document.createElement('span');
                nameSpan.innerHTML = teamsTeamName;

                cellContainer.appendChild(ico);
                cellContainer.appendChild(nameSpan)
                break;
            case "channelID".toLowerCase():
                cellContainer.innerHTML = '<span class="bold" title="' + entity.channelDisplayName + '">' + entity.channelDisplayName + '</span>';
                break;
            case "channelDescription".toLowerCase():
                cellContainer.innerHTML = '<span class="preservePlainTextNewLine" title="' + entity.channelDescription + '">' + entity.channelDescription + '</span>';
                break;
            default:
                console.warn("not handled formating cell", columnName, entity, node);
                reflectChanges = false;
                break;
        }
        return reflectChanges;
    }

    private onOpenTabEditor(rowGroup: StaticTable.StaticTableRowGroup<any>) {
        let entity: TeamsChannelApiData = rowGroup.entity;
        if (this.configurationDlg != null) {
            try{
                this.configurationDlg.destroyRecursive();
            }catch{}
        }
        if (this.channelTabEditor != null){
            try{
                this.channelTabEditor.destroyRecursive();
            }catch{}
        }

        this.channelTabEditor = new channel_tab_configuration();
        this.channelTabEditor.loadChannelByEntityId(entity.ID, entity.channelDisplayName, entity.parentTeamDisplayName);
        this.channelTabEditor.setMdscTabAppIsInstalled(this.mdscTabAppIsInstalledInTeams);

        this.configurationDlg = new GenericDialog();
        this.configurationDlg.show(
            this.channelTabEditor,
            this.translate("MsTeamsIntegration_AdminPanel_TabConf_Header") + " " + entity.channelDisplayName,
            null,
            null,
            'close',
            null
        );
        this.channelTabEditor.setDlg(this.configurationDlg);
    }

    private onCanOpenTabEditor(entity: TeamsChannelApiData, rowGroup: StaticTable.StaticTableRowGroup<any>): boolean {
        return entity.channel_isArchived == false;
    }

    private _onClick_OpenEdit(rowGroup: StaticTable.StaticTableRowGroup<TeamsChannelApiData>){
        if (this.channelEditor != null){
            try{
                this.channelEditor.destroyRecursive();
            }catch{}
        }
        this.channelEditor = new mst_chnl_conf();
        this.channelEditor.setValue(rowGroup.entity);
        this.channelEditor.openInDlg(lang.hitch(this, ()=>{
            this.showLoading();
            this.reloadTimeout = setTimeout(() => { //timeout weil graph api nicht so schnell ist...
                this.hideLoading();
                this.reloadTimeout = null;
                this.reloadData();
            }, 300);
        }));
    }

    private onDelete_Channel(rowGroup: StaticTable.StaticTableRowGroup<any>) {
        let entity: TeamsChannelApiData = rowGroup.entity;
        let entityId = entity.ID;
        if (this.configurationDlg != null) {
            try {
                this.configurationDlg.destroyRecursive();
            } catch { }
        }

        this.configurationDlg = new GenericDialog();
        this.configurationDlg.setSize('smaller')

        this.configurationDlg.addButton("deleteOnlyEntity", this.translate("MsTeamsIntegration_AdminPanel_DeleteDlg_OnlyEntity"), () => {
            this.request_delete(entityId, true);
        });
        this.configurationDlg.addButton("fullDelete", this.translate("MsTeamsIntegration_AdminPanel_DeleteDlg_Full"), () => {
            this.request_delete(entityId, false);
        });

        let teamDN = entity.parentTeamDisplayName;
        let channelDN = entity.channelDisplayName;
        let confirmDlgTxt = this.getTranslation("MsTeamsIntegration_AdminPanel_DeleteDlg_InfoTxt") + "<br><br>";
        confirmDlgTxt += '<div class="displayInlineBlock">';
        confirmDlgTxt += '<i class="fas fa-users"></i> <span class="italic maxWidth32Ch" title="' + teamDN + '">' + teamDN + '</span>';
        confirmDlgTxt += '</div>';

        confirmDlgTxt += '<br><i class="fas fa-angle-right paddingSmallLeft w3-padding-right"></i> ';

        confirmDlgTxt += '<div class="displayInlineBlock">'
        confirmDlgTxt += '<i class="far fa-comments"></i> <span class="maxWidth32Ch" title="' + channelDN + '">' + channelDN + '</span>';
        confirmDlgTxt += '</div>';

        this.configurationDlg.show(
            confirmDlgTxt,
            this.getTranslation("MsTeamsIntegration_AdminPanel_Channel"),
            null,
            "fas fa-dumpster w3-xxxlarge w3-margin",
            'close',
            (choice: number) => {
                if (choice == 0) {//cancel
                    this.reloadData();
                }
            }
        );
    }
    private async request_delete(entityId: string, onlyDeleteEntity: boolean) {
        this.showLoading();

        let reqPromise: Promise<{}> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__DeleteChannelObject",
                {
                    deleteEntityOnly: onlyDeleteEntity ?? false,
                    entityID: entityId
                },
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-exclamation-triangle");
                    reject(err);
                })
            );
        });

        try {
            await reqPromise;
        } catch {
            this.hideLoading();
            this.reloadData();
            return;
        }
        this.hideLoading();
        this.showToast(this.translate("General_Delete_Success"), "fas fa-check");
    }

    private onIsDeletable_Channel(entity: TeamsChannelApiData, rowGroup: StaticTable.StaticTableRowGroup<any>): boolean {
        //TODO - check if in team context, if yes -
        return entity.channel_isArchived == false;
    }

    private newBtnFloagMenu: MdsLax<InstanceType<typeof FloatingMenu>> = null;
    private _onClick_NewBtn(ev: Event) { // btn in template
        //this._onClick_ShowNewChannelDlg();
        //_onClick_ImportChannel();
        if (this.newBtnFloagMenu != null){
            this.newBtnFloagMenu.destroyRecursive();
        }
        this.newBtnFloagMenu = new FloatingMenu();
        this.newBtnFloagMenu.open(ev, [
            {
                label: this.translate("MsTeamsIntegration_AdminPanel_NewBtn_Import"),
                callback:lang.hitch(this, this._onClick_ImportChannel),
                enabled:true,
                icon:"fas fa-level-down-alt",
                heading: this.translate("MsTeamsIntegration_AdminPanel_NewBtn")
            },
            {
                label: this.translate("MsTeamsIntegration_AdminPanel_NewBtn_Create"),
                callback: lang.hitch(this, this._onClick_ShowNewChannelDlg),
                enabled: true,
                icon: "fas fa-plus-circle",
                heading: this.translate("MsTeamsIntegration_AdminPanel_NewBtn")
            }
        ]);
    }
    private channelFinderWidget: MdsLax<InstanceType<typeof teams_channel_finder>> = null;

    private _onClick_ImportChannel() {
        if (this.configurationDlg != null) {
            try {
                this.configurationDlg = new GenericDialog();
            } catch { }
        }
        if (this.channelFinderWidget != null) {
            try {
                this.channelFinderWidget.destroyRecursive();
            } catch { }
        }
        this.configurationDlg = new GenericDialog();
        this.channelFinderWidget = new teams_channel_finder();
        this.channelFinderWidget.on("entitySelected", lang.hitch(this, async (entity: { teamID: string, ID: string }) => {
            let teamId = entity.teamID;
            let channelId = entity.ID;
            this.configurationDlg.close();
            this.showLoading();
            let importPromise: Promise<{ ID: string }> = new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_API_MS_Teams_Integration_AdminPanel__ImportChannelToObject",
                    { teamID: teamId, channelID: channelId },
                    lang.hitch(this, (result: any) => {
                        resolve(result);
                    }),
                    lang.hitch(this, (err) => {
                        console.error(err.Message);
                        this.showToast(err.Message, "fas fa-bug");
                        reject(err);
                    })
                );
            });
            let resultObject: { ID: string } = null;
            try {
                resultObject = await importPromise;
            } catch {

                return;
            }
            console.info("Imported teams channel to entity. New Entity", resultObject.ID, "Channel API info:", teamId, channelId);
            this.hideLoading();
            this.reloadData();
        }));
        this.configurationDlg.show(
            this.channelFinderWidget,
            this.translate("MsTeamsIntegration_AdminPanel_Channels"),
            null,
            null,
            null,
            null,
            {
                additionalButtons: [
                    {
                        internalName: "justCancel",
                        callback: lang.hitch(this, () => {
                            this.configurationDlg.close();
                            this.reloadData();
                        }),
                        label: this.translate("General_Cancel")
                    }
                ],
            }
        );
    }

    private teamSelectorWidget: MdsLax<InstanceType<typeof teams_team_finder>> = null;
    private _onClick_ShowNewChannelDlg() { //blub
        if (this.configurationDlg != null) {
            try {
                this.configurationDlg.destroyRecursive();
            } catch { }
        }
        this.configurationDlg = new GenericDialog();
        if (this.teamSelectorWidget != null) {
            try {
                this.teamSelectorWidget.destroyRecursive();
            } catch { }
        }
        this.teamSelectorWidget = new teams_team_finder();

        this.teamSelectorWidget.on("selectedTeamID", lang.hitch(this, (res: { ID: string, displayName: string }) => {
            this.configurationDlg.close();
            this._onNewChannel_Create(res.ID, res.displayName);
        }));

        this.configurationDlg.show(
            this.teamSelectorWidget,
            this.translate("MsTeamsIntegration_AdminPanel_NewChannel_SelectTeam"),
            null,
            null,
            null,
            null,
            {
                additionalButtons: [
                    {
                        internalName: "justCancel",
                        callback: lang.hitch(this, () => {
                            this.configurationDlg.close();
                            this.reloadData();
                        }),
                        label: this.translate("General_Cancel")
                    }
                ],
            }
        );
    }

    private _onNewChannel_Create(targetTeamId: string, targetTeamDisplayName: string, channelDisplayName: string = null, channelDescription: string = null) {
        if (this.configurationDlg != null) {
            try {
                this.configurationDlg.destroyRecursive();
            } catch { }
        }
        this.configurationDlg = new GenericDialog();

        let basicTeamConfigWidget = new mst_chnl_conf();
        basicTeamConfigWidget.hide_IsArchived(true);
        if ((channelDisplayName != null) || (channelDescription != null)) {
            basicTeamConfigWidget.setValue({
                web_url: null,
                channel_isArchived: false,
                channelDescription: channelDescription,
                channelDisplayName: channelDisplayName,
                channelID: null,
                ID: null,
                parentTeamDisplayName: null,
                parentTeamID: null,
            });
        }

        this.configurationDlg.show(
            basicTeamConfigWidget,
            this.translate("MsTeamsIntegration_AdminPanel_NewChannel_Header"),
            this.translate("MsTeamsIntegration_AdminPanel_NewChannel_Sub") + ' <i class="fas fa-users"></i> <span class="italic">' + targetTeamDisplayName + '</span>',
            null,
            'saveclose',
            async (selectedDlgBtn: number) => {
                this.configurationDlg.close();
                if (selectedDlgBtn == 1) {
                    //save btn
                    let val = basicTeamConfigWidget.getValue();
                    //displayName muss mindestens ein Zeichen haben
                    if (!val.displayName || val.displayName.trim() == "") {
                        this.showToast(this.getTranslation("MsTeamsIntegration_AdminPanel_NewChannel_InvalidDisplayName"), "fas fa-times");
                        this._onNewChannel_Create(targetTeamId, targetTeamDisplayName, val.displayName, val.description);
                        return;
                    }
                    this.createNewChannel(targetTeamId, val.displayName, val.description);
                }
            }
        );
    }

    private async createNewChannel(teamId: string, displayName: string, description: string) {
        this.showLoading();
        let reqProm = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__CreateNewChannel",
                {
                    teamID: teamId,
                    displayName: displayName,
                    description: description,
                    channelType: "standard", //standard (private not implemented)
                    privateChannelGuestEmails: []//Array<string> (wenn private fuer members, not implemented)
                },
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-exclamation-triangle");
                    reject(err);
                })
            );
        });

        try {
            await reqProm;
        } catch {
        }
        if (this.configurationDlg != null) {
            try {
                this.configurationDlg.close();
            } catch { }
        }
        this.hideLoading();
        this.reloadData();
    }

    private showLoading(){
        this.StandbyStart();
        if (this.myDlg != null){
            this.myDlg.disableAllButtons(true);
        }
    }
    private hideLoading(){
        this.StandbyStop();
        if (this.myDlg != null) {
            this.myDlg.disableAllButtons(false);
        }
    }

    public showDlg() {

        if (this.myDlg != null){
            this.myDlg.destroy();
        }
        this.myDlg = new GenericDialog();
        this.myDlg.setSize('largest');
        this.myDlg.show(
            this,
            null,
            null,
            null,
            'close',
            null,
            null
        )
    }

    destroy(preserveDom?: boolean): void {
        if (this.reloadTimeout != null){
            clearTimeout(this.reloadTimeout);
        }
    }
}

export default mdsWidget(confpan);
